import cache from '../utility/cache'

export default {
    state: {
        currentMenuKey: cache.fetchMenuKey(),
        humberOpen: true
    },
    mutations: {
        changeKey(state, key) {
            state.currentMenuKey = key;
        },
        changeHumberOpen(state, key) {
            state.humberOpen = key;
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/layout-store.js